module.exports = __webpack_public_path__ + "biao16.jpg?f3e1a12";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao16.jpg
 ** module id = 51
 ** module chunks = 0
 **/